var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              on: { change: _vm.handleChange },
              model: {
                value: _vm.collapse,
                callback: function ($$v) {
                  _vm.collapse = $$v
                },
                expression: "collapse",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "Phone Number", name: "phoneNumber" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Phone number", prop: "phone_number" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            remote: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Search",
                            "remote-method": _vm.searchContact,
                            loading: _vm.contactsLoading,
                          },
                          model: {
                            value: _vm.form.phone_number,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "phone_number", $$v)
                            },
                            expression: "form.phone_number",
                          },
                        },
                        _vm._l(_vm.contactOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "Email", name: "email" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email", prop: "email" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            remote: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Search",
                            "remote-method": _vm.searchContact,
                            loading: _vm.contactsLoading,
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email",
                          },
                        },
                        _vm._l(_vm.contactOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "mt-3",
              attrs: { label: "Brand", prop: "brand_id" },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { clearable: "", placeholder: "Brand" },
                  model: {
                    value: _vm.form.brand_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "brand_id", $$v)
                    },
                    expression: "form.brand_id",
                  },
                },
                _vm._l(_vm.brandOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-create px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }